import { IMAGES } from "./tokens";

/**
 * The monorail.
 *
 * Founder's design: a Disney-style tour of the World before it unlocks. MelzAI
 * hosts, pausing on the EXTERIOR of each Place, saying what is open today and
 * teasing the rest — then releasing the traveller with a World Map in the
 * corner, like the paper park map Disney used to hand out.
 *
 * Founder's hard rule: exteriors only. "They get teased with maybe a shot, but
 * they have to go in themselves." Nothing inside a Space is ever pre-filled,
 * which is exactly why the tour cannot break: it carries no state.
 *
 * NAMES ARE LOCKED. Taglines, body copy and clock positions are the founder's
 * own words, taken verbatim from his design sheet — do not paraphrase them.
 */
export const MONORAIL = [
  {
    key: "arcade",
    name: "Pursuital Arcade",
    clock: "10 o'clock",
    plate: "pfArcadeApproach",
    open: true,
    to: "/playforward",
    portal: "playforward",
    practice: "PlayForward",
    tagline: "Where a want becomes a wager.",
    body: "Every screen inside is about you, and nobody else is on the board. One vague want, cut down to one Slice you can actually finish.",
  },
  {
    key: "arena",
    name: "The Arena",
    clock: "12 o'clock",
    plate: "exArena",
    open: false,
    practice: "Contest",
    tagline: "Where intent is tested in the open.",
    body: "Bring the endeavor, take the pressure, learn what holds.",
  },
  {
    key: "ops",
    name: "Ops",
    clock: "2 o'clock",
    plate: "exOps",
    open: false,
    practice: "Make",
    tagline: "Where counsel becomes a venture.",
    body: "Onboarding interview on a cluttered stage — which clears, and the blank board becomes yours. MullMind, one to one. Houses the Studio Space (LunchOur broadcast set).",
  },
  {
    key: "chamber",
    name: "Mastermind Chamber",
    clock: "3 o'clock",
    plate: "exChamber",
    open: false,
    practice: "Counsel",
    tagline: "Where many minds sit with one question.",
    body: "MultMind proper: four unleashed AI around one packet. You brought the mulling; they bring the pressure.",
  },
  {
    key: "bridge",
    name: "The Bridge",
    clock: "5 o'clock",
    plate: "exBridge",
    open: false,
    practice: "Cross",
    tagline: "Where plans are drawn against the horizon.",
    body: "The last room before Execution — where the Horizon Map is made.",
  },
  {
    key: "hall",
    name: "Clarity Hall",
    clock: "7 o'clock",
    plate: "swHallApproach",
    open: true,
    to: "/stageward/walk",
    portal: "stageward",
    practice: "Stageward",
    tagline: "Where the how gets worked out.",
    body: "The Arcade asks what. The Hall asks how — heavier work, so the whole building changes register.",
  },
  {
    key: "vault",
    name: "The Vault",
    clock: "8 o'clock",
    plate: "exVault",
    open: false,
    practice: "Keep",
    tagline: "Archive, record, reflect, evolve.",
    body: "It says so on the door. What you have earned and what you have promised, kept where neither can be quietly forgotten.",
  },
  {
    key: "commons",
    name: "The Commons",
    clock: "9 o'clock",
    plate: "exCommons",
    open: false,
    practice: "Gather",
    tagline: "Where nobody finishes alone.",
    body: "A fire, a table, and the people who nudged you.",
  },
];

/** Any stop whose plate has not landed is skipped, never shown as a hole. */
export const STOPS = MONORAIL.filter((s) => Boolean(IMAGES[s.plate]));

export const OPEN_TODAY = MONORAIL.filter((s) => s.open);

/** "Eight Places. Two open today." — said out loud, never apologised for. */
export const worldCount = () => ({
  places: MONORAIL.length,
  open: OPEN_TODAY.length,
});
